import React from 'react';
import { DownloadContainer, DownloadDescription, DownloadFileIcon } from '../../Download';
import { FileState, IFileItem } from '../../../../types/api/FileItem';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { StatusInfoError } from '../../StatusInfo';

export function PendingDownload({ fileExtension, fileName, fileState }: IFileItem) {
  const { t } = useSonTranslation('AttachedFiles');
  return (
    <DownloadContainer>
      <DownloadFileIcon fileExtension={fileExtension} />
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className="attached-files-base__pending-file-link font-bold-15-19" aria-disabled="true" role="link">
        {fileName}
      </a>
      {fileState === FileState.pending
        ? (
            <DownloadDescription>{t('pendingMessage')}</DownloadDescription>
          )
        : (
            <StatusInfoError message={t('moveElementNotPersisted')} modifier="red" />
          )}
    </DownloadContainer>
  );
}
